<template>
  <div v-if="weatherConditions.length" class="text-secondary">
    <template v-for="(wc, index) in weatherConditions">
      <b-badge variant="secondary" :key="wc" :class="{ 'ml-2': index === 0, 'ml-1': index > 0 }">
        <b-link :to="{ name: 'pois-list', query: { weather: wc } }" class="text-light">
          <font-awesome-icon :icon="getFontAwesomeIcon(wc)" />
        </b-link>
      </b-badge>
    </template>
  </div>
</template>

<script>
export default {
  name: 'WeatherIcons',
  props: {
    weatherConditions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      weatherIconMaping: {
        cloudy: { fa: { icon: 'cloud' } },
        foggy: { fa: { icon: 'smog' } },
        moon: { fa: { icon: 'moon' } },
        'moon-cloudy': { fa: { icon: 'cloud-moon' } },
        rainy: { fa: { icon: 'cloud-showers-heavy' } },
        snow: { fa: { icon: 'snowflake' } },
        sunny: { fa: { icon: 'sun' } },
        'sunny-cloudy': { fa: { icon: 'cloud-sun' } },
        'sunny-cloudy-rainy': { fa: { icon: 'cloud-sun-rain' } },
        undefined: { fa: { style: 'far', icon: 'question-circle' } },
      },
    };
  },
  methods: {
    getFontAwesomeIcon(wc) {
      const faMapping = this.weatherIconMaping;
      let faIcon = [];
      if (wc in faMapping) {
        faIcon = faMapping[wc].fa.style
          ? [faMapping[wc].fa.style, faMapping[wc].fa.icon]
          : ['fas', faMapping[wc].fa.icon];
      } else {
        faIcon = [faMapping.undefined.fa.style, faMapping.undefined.fa.icon];
      }
      return faIcon;
    },
  },
};
</script>

<style scoped></style>
